<template>
  <div class="balance-dropdown container">
    <div class="balance-dropdown__header">
      <UiText font="body-h2" text="Твій баланс" color="typography-title01" />
      <div class="balance-dropdown__icon-wrapper" @click="closeDropdown">
        <SvgIcon name="common/close" class="balance-dropdown__header-icon" />
      </div>
    </div>
    <div class="balance-dropdown__content">
      <div class="balance-dropdown__item">
        <UiText
          class="balance-dropdown__item-title"
          :text="$tc('header.balanceDropdown.titleBalance')"
          font="body-text"
          color="typography-body01"
        />
        <div class="balance-dropdown__value margin">
          <UiText
            font="promo-heading-2"
            :text="c_balance.balance"
            color="button-default-text-color"
            class="balance-dropdown__sum"
          />
          <UiText
            font="promo-heading-3"
            text="₴"
            color="button-default-text-color"
            class="balance-dropdown__currency"
          />
        </div>
        <UiBtn
          class="balance-dropdown__item-btn"
          :to="$paths.cashbox"
          size-small
          :text="$tc('header.balanceDropdown.btnPayIn')"
          color="primary"
        />
      </div>
      <div class="balance-dropdown__item">
        <UiText
          class="balance-dropdown__item-title"
          :text="$tc('header.balanceDropdown.titleWithdrawal')"
          font="body-text"
          color="typography-body01"
        />
        <div class="balance-dropdown__value margin">
          <UiText
            font="promo-heading-2"
            :text="c_balance.maxPayout"
            color="button-default-text-color"
            class="balance-dropdown__sum"
          />
          <UiText
            font="promo-heading-3"
            text="₴"
            color="button-default-text-color"
            class="balance-dropdown__currency"
          />
        </div>
        <UiBtn
          class="balance-dropdown__item-btn"
          :to="$paths.cashboxWthdrawal"
          size-small
          :text="$tc('header.balanceDropdown.btnPayOut')"
          color="default"
        />
      </div>
      <div class="balance-dropdown__item">
        <UiText
          class="balance-dropdown__item-title"
          :text="$tc('header.balanceDropdown.titleBonus')"
          font="body-text"
          color="typography-body01"
        />
        <div class="balance-dropdown__value">
          <UiText
            font="promo-heading-2"
            :text="c_balance.bonus"
            color="button-default-text-color"
            class="balance-dropdown__sum"
          />
          <UiText
            font="promo-heading-3"
            text="₴"
            color="button-default-text-color"
            class="balance-dropdown__currency"
          />
        </div>
      </div>
      <div class="balance-dropdown__item">
        <UiText
          class="balance-dropdown__item-title"
          :text="$tc('header.balanceDropdown.titleWager')"
          font="body-text"
          color="typography-body01"
        />
        <div class="balance-dropdown__value">
          <UiText
            font="promo-heading-2"
            :text="c_balance.wager"
            color="button-default-text-color"
            class="balance-dropdown__sum"
          />
          <UiText
            font="promo-heading-3"
            text="₴"
            color="button-default-text-color"
            class="balance-dropdown__currency"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { formatNumberFilter } from '@/util/helpers/vueFilters'

export default {
  name: 'BalanceDropdown',
  computed: {
    ...mapGetters('user', [
      'balance',
      'maxPayout',
      'bonusBalance',
      'wagerBalance',
      'isUserLoaded',
    ]),
    c_balance() {
      return this.isUserLoaded
        ? {
          balance: formatNumberFilter(this.balance,{ format: 'currency' }),
          maxPayout: formatNumberFilter(this.maxPayout,{ format: 'currency' }),
          bonus: formatNumberFilter(this.bonusBalance,{ format: 'currency' }),
          wager: formatNumberFilter(this.wagerBalance,{ format: 'currency' }),
        }
        : {
          balance: '--',
          maxPayout: '--',
          bonus: '--',
          wager: '--',
        }
    },
  },
  methods: {
    ...mapActions('base', ['closeDropdown']),
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
